<template>
  <header class="header-container">
    <div class="header-wrapper">
      <div class="logo">老军号康养网</div>
      <!-- 汉堡按钮（手机显示） -->
      <div class="hamburger" @click="showMenu = !showMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="nav-box" :class="{ show: showMenu }">
        <div class="nav-item" :class="{ activeStyle: activeNav == item.name }" @click="toNav(item, i + 1)"
          v-for="(item, i) in navList" :key="item.path">
          <div class="name">{{ item.name }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    nav: String,
  },
  data() {
    return {
      showMenu: false,
      activeNav: "首页",
      navList: [
        { name: "首页", path: '/', text: "Home" },
        { name: "集团业务", path: '/groupBusiness', text: "Group Business" },
        { name: "集团新闻", path: '/groupNews', text: "Group News" },
        { name: "专家团队", path: '/expertTeam', text: "Expert Team" },
        { name: "关于我们", path: '/aboutUs', text: "About Us" },
      ],
    }
  },
  watch: {
    $route() {
      this.setActiveNav();
    }
  },
  created() {
    this.setActiveNav()
  },
  methods: {
    setActiveNav() {
      const path = this.$route.path;
      const item = this.navList.find((n) => n.path === path);
      if (item) {
        this.activeNav = item.name;
      } else if(!item && path == '/GroupDetail') {
        this.activeNav = '集团业务'
      } else if (!item && path == '/NewsDetail') {
        this.activeNav = '集团新闻'
      }

    },
    toNav(item, i) {
      this.$router.push({
        path: item.path,
        query: {
          id: i,
        }
      })
      this.activeNav = item.name;
      this.showMenu = false
    },
  },
}
</script>

<style scoped lang="scss">
.header-container {
  width: 100%;
  background-color: transparent !important;
  height: 70px;
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 999;
  box-shadow: none;
  backface-visibility: hidden;
  transform: translateZ(0);

  .header-wrapper {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    border-bottom: 2px solid #fff;
    position: relative;

    .logo {
      font-size: 24px;
      font-weight: bold;
      color: #0A51A5;
      cursor: pointer;
      padding-bottom: 20px;
    }

    // 汉堡按钮 → 手机显示
    .hamburger {
      display: none;
      flex-direction: column;
      gap: 4px;
      cursor: pointer;
      padding: 10px 0;

      span {
        width: 24px;
        height: 2px;
        background: #fff;
      }
    }

    .nav-box {
      width: 60%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      cursor: pointer;

      .nav-item {
        padding-bottom: 20px;
        position: relative;
        transition: all 0.3s ease;

        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -2px;
          width: 0;
          height: 2px;
          background: #0A51A5;
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }
      }

      .activeStyle::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -2px;
        width: 0;
        height: 2px;
        background: #0A51A5;
        transition: all 0.3s ease;
        transform: translateX(-50%);
        width: 100%;
      }

      .name {
        font-size: 18px;
        color: #fff;
      }

      .text {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}

@media (max-width: 992px) {
  .header-container .header-wrapper {
    width: 70%;

    .nav-box {
      width: 70%;
    }
  }
}

@media (max-width: 768px) {
  .header-container {
    top: 30px;
    height: auto;

    .header-wrapper {
      border-bottom: 1px solid #fff;
      padding: 10px 0;

      // 显示汉堡
      .hamburger {
        display: flex;
      }

      // 手机隐藏导航
      .nav-box {
        display: none;
        position: absolute;
        top: 70px;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.7);
        flex-direction: column;
        padding: 20px 0;
        border-radius: 10px;

        .nav-item {
          padding: 10px 0;
          text-align: center;
        }
      }

      // 点击展开
      .nav-box.show {
        display: flex;
      }
    }
  }
}
</style>